import styles from './grow.module.css';

import type { BreakpointSize } from '../../styles/Breakpoint';

export type GrowContentResponsive = Partial<Record<BreakpointSize, boolean>>;
export type GrowContent = boolean | GrowContentResponsive;

export type GridGrowProps = {
  /** Set the children with `flex-grow: 1` */
  growContent?: GrowContent;
};

export function getGrowStyles(props: GridGrowProps): string[] {
  const growStyles: string[] = [];
  let { growContent } = props;

  if (typeof growContent === 'boolean') {
    growContent = { xs: growContent };
  }
  if (growContent?.xs !== undefined) {
    growStyles.push(styles[`grow-xs-${growContent.xs ? 1 : 0}`]);
  }
  if (growContent?.sm !== undefined) {
    growStyles.push(styles[`grow-sm-${growContent.sm ? 1 : 0}`]);
  }
  if (growContent?.md !== undefined) {
    growStyles.push(styles[`grow-md-${growContent.md ? 1 : 0}`]);
  }
  if (growContent?.lg !== undefined) {
    growStyles.push(styles[`grow-lg-${growContent.lg ? 1 : 0}`]);
  }
  if (growContent?.xl !== undefined) {
    growStyles.push(styles[`grow-xl-${growContent.xl ? 1 : 0}`]);
  }
  return growStyles;
}
